<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Occupation Pensions</h1>
    <p>In addition to auto enrolment workplace pension schemes, some companies also operate occupational schemes.</p>
    <p>Do you operate any non-auto enrolment pension schemes (for example, stakeholder pensions or defined benefit schemes)?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasNonAePensions">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasNonAePensions">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})

const validateStep = () => {
  if (props.formData.hasNonAePensions === undefined || props.formData.hasNonAePensions === null || props.formData.hasNonAePensions === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}



const executeStep = async () => {
  return true;
}



defineExpose({ validateStep, executeStep });

</script>